export default __webpack_public_path__ + "static/media/a6_folding_card_landscape.92f48308.png";